import ApiService from './ApiService';

class CompanySettingsServices {
  static async getCompanySettings() {
    const composedURL = '/api3/company/configuration';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getWatermarkSettings() {
    const composedURL = '/api3/company/watermark_config';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async updateWatermarkSettings(requestBody) {
    const composedURL = '/api3/company/watermark_config';
    const response = await ApiService.put(composedURL, requestBody);
    return response;
  }

  static async getTimezones() {
    const composedURL = '/api3/core/timezone_choices';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async updateCompanySettings(requestBody) {
    const composedURL = '/api3/company/configuration';
    const response = await ApiService.put(composedURL, requestBody);
    return response;
  }

  static async uploadCompanyImages(arg) {
    const composedURL = '/api3/company/image_upload';

    const requestBody = arg?.requestBody ?? arg;

    const response = await ApiService.put(
      composedURL,
      requestBody,
      undefined,
      true
    );
    return response;
  }

  static async regenerateApiKey() {
    const composedURL = '/api3/company/configuration/regenerate_api_key';
    const response = await ApiService.post(composedURL, {});
    return response;
  }
}

export default CompanySettingsServices;
